import initStore from './init-store.js';

import reducer from './reducers/index.js';

const store = initStore(reducer);

window.store = store;

export default store;
